import { axiosApi } from '../../../plugins/api';
import { APP_ID } from '../../../constant';

/**
 * 获取学校列表数据
 * mock  await httpGet({url: '/school/info'});
 * @returns 学校列表数据
 */
export const getSchoolListInfo = axiosApi({
  url: '/api/school/query/list',
  method: 'GET',
  params: {
    appId: APP_ID,
  },
});

/**
 * 认证绑定
 * mock axios.post('/user/bind').then((response) => {
 */
export const postAuthBindInfo = axiosApi({
  url: '/api/account/user/bind',
  method: 'POST',
});
